<form class="" [formGroup]="MRIAppoinmentForm">
  <div class="row g-3 align-items-end">
    <div class="col-md-12 d-flex gap-4 align-items-center">
      <h5 class="mb-0">Carvical</h5>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="noCervicalMRI" formControlName="noCervicalMRI" />
        <label class="form-check-label" for="noCervicalMRI">No Carvical MRI </label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <label for="cmriFacilityId">Facility</label>
        <div class="input-group">
          <select class="form-select form-control" id="cmriFacilityId" aria-label="facility" formControlName="cmriFacilityId">
            <option [value]="0">-- None --</option>
            <option *ngFor="let option of facilities" [value]="option.id">
              {{ option.mriFacilityName }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label for="cSchedDate">Schedule Date</label>
        <div class="input-group" id="cSchedDateDiv">
          <input type="date" class="form-control" id="cSchedDate" formControlName="cSchedDate" placeholder="Next MD Appointment" />
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" id="cScanDone" formControlName="cScanDone" />
        <label class="form-check-label" for="cScanDone">Scan Done </label>
      </div>
    </div>
  </div>

  <hr class="my-4" />

  <div class="row g-3 align-items-end">
    <div class="col-md-12 d-flex gap-4 align-items-center">
      <h5 class="mb-0">Thoracic</h5>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="noThoracicMRI" formControlName="noThoracicMRI" />
        <label class="form-check-label" for="noThoracicMRI">No Thoracic MRI </label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <label for="tmriFacilityId">Facility</label>
        <div class="input-group">
          <select class="form-select form-control" id="tmriFacilityId" aria-label="facility" formControlName="tmriFacilityId">
            <option [value]="0">-- None --</option>
            <option *ngFor="let option of facilities" [value]="option.id">
              {{ option.mriFacilityName }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label for="tSchedDate">Schedule Date</label>
        <div class="input-group" id="tSchedDateDiv">
          <input type="date" class="form-control" id="tSchedDate" formControlName="tSchedDate" placeholder="Next MD Appointment" />
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" id="tScanDone" formControlName="tScanDone" />
        <label class="form-check-label" for="tScanDone">Scan Done </label>
      </div>
    </div>
  </div>

  <hr class="my-4" />

  <div class="row g-3 align-items-end">
    <div class="col-md-12 d-flex gap-4 align-items-center">
      <h5 class="mb-0">Lumbar</h5>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="noLumbarMRI" formControlName="noLumbarMRI" />
        <label class="form-check-label" for="noLumbarMRI">No Lumbar MRI </label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <label for="lmriFacilityId">Facility</label>
        <div class="input-group">
          <select class="form-select form-control" id="lmriFacilityId" aria-label="facility" formControlName="lmriFacilityId">
            <option [value]="0">-- None --</option>
            <option *ngFor="let option of facilities" [value]="option.id">
              {{ option.mriFacilityName }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label for="lSchedDate">Schedule Date</label>
        <div class="input-group" id="lSchedDateDiv">
          <input type="date" class="form-control" id="lSchedDate" formControlName="lSchedDate" placeholder="Next MD Appointment" />
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" id="lScanDone" formControlName="lScanDone" />
        <label class="form-check-label" for="lScanDone">Scan Done </label>
      </div>
    </div>
  </div>

  <hr class="my-4" />

  <div class="row gap-3 mb-3">
    <div class="col-md-12 d-flex gap-4 align-items-center">
      <h5 class="mb-0">Extrimity / Brain</h5>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="noExtremityMRI" formControlName="noExtremityMRI" />
        <label class="form-check-label" for="noExtremityMRI"> No Extrimity MRI </label>
      </div>
    </div>

    <ng-container *ngFor="let item of [1, 2, 3, 4]">
      <div class="d-flex gap-3 align-items-end">
        <div class="col-md-3">
          <div class="form-group">
            <label for="omriType{{ item }}">Area</label>
            <div class="input-group">
              <select class="form-select form-control" id="omriType{{ item }}" aria-label="area" formControlName="omriType{{ item }}">
                <option [value]="0">-- None --</option>
                <option *ngFor="let option of mriTypes" [value]="option.key">
                  {{ option.value }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="omriFacilityId{{ item }}">Facility</label>
            <div class="input-group">
              <select class="form-select form-control" id="omriFacilityId{{ item }}" formControlName="omriFacilityId{{ item }}" aria-label="facility">
                <option [value]="0">-- None --</option>
                <option *ngFor="let option of facilities" [value]="option.id">
                  {{ option.mriFacilityName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="omriSchedDate{{ item }}">Schedule Date</label>
            <div class="input-group" id="omriSchedDate{{ item }}Div">
              <input type="date" class="form-control" id="omriSchedDate{{ item }}" formControlName="omriSchedDate{{ item }}" placeholder="Next MD Appointment" />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-check mb-2">
            <input class="form-check-input" type="checkbox" id="oScanDone{{ item }}" formControlName="oScanDone{{ item }}" />
            <label class="form-check-label" for="oScanDone{{ item }}">Scan Done </label>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</form>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
  <button type="button" class="btn btn-primary" (click)="isData ? updateMRIAppointment() : makeMRIAppoinment()" [disabled]="patientData.isDischarged">
    {{ isData ? 'Update' : 'Create' }} Appointment
  </button>
</div>
